/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/ManualWIFComponent" />

import React = require("react");

import { equals } from "VSS/Core/Util/String";

import { AzureEndpointConstants } from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { DraftWIFEndpointComponent } from "./DraftWIFEndpointComponent";
import { FinalizeWIFEndpointComponent } from "./FinalizeWIFEndpointComponent";
import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { EndpointsEditorStore } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/EndpointsEditorStore";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import { EditManualWIFEndpointComponent } from "./EditManualWIFEndpointComponent";

interface IManualWIFComponentState {
    isUpdateFlow: boolean;
    isNewEmptyEndpoint: boolean;
}

export class ManualWIFComponent extends VssComponent<{}, IManualWIFComponentState> {

    private readonly _endpointEditorStore: EndpointsEditorStore;
    private readonly _originalEndpoint: ServiceEndpoint;

    constructor(context: IVssComponentContext) {
        super(context);

        this._endpointEditorStore = StoreManager.GetStore<EndpointsEditorStore>(EndpointsEditorStore, ActionsCreatorInstanceIds.EndpointsEditorStoreInstanceId);
        this._endpointEditorStore.addChangedListener(this._onEndpointStoreChange);

        this._originalEndpoint = this._endpointEditorStore.getEndpointClone();

        this.state = this.createManualWIFComponentState();
    }

    public componentWillUnmount(): void {
        this._endpointEditorStore.removeChangedListener(this._onEndpointStoreChange);
    }

    public render(): JSX.Element {
        return (<div className="endpoint-editor-panel-content azure-rm-workload-identity-federation-container">
            {this.renderEndpointForm()}
        </div>);

    }

    private renderEndpointForm(): JSX.Element {
        if (this.state.isUpdateFlow) {
            return <EditManualWIFEndpointComponent />;
        }

        if (this.state.isNewEmptyEndpoint) {
            return <DraftWIFEndpointComponent />;
        }

        return <FinalizeWIFEndpointComponent />;
    }

    private _onEndpointStoreChange = (): void => {
        const state = this.createManualWIFComponentState();
        this.setState(state);
    }

    private createManualWIFComponentState(): IManualWIFComponentState {
        const endpointEditorState = this._endpointEditorStore.getState();
        const endpoint = endpointEditorState.serviceEndpoint;

        return {
            isUpdateFlow: !equals(endpoint.data[AzureEndpointConstants.IsDraft], "true", true) && !!this._originalEndpoint.id,
            isNewEmptyEndpoint: !endpoint.id
        };
    }
}

